import { type MediumIcon, SelectOption } from '@factorialco/deprecated-design-system'
import { IconType } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

import { ALLOWED_VIEWS_BY_GROUP } from 'modules/shift_management/store/internal/models/View'
import type {
  GroupOption,
  GroupType,
  ViewByGroup,
  ViewType,
} from 'modules/shift_management/store/internal/models/View'

const labelTranslation = (key: ViewType | GroupType): string => {
  switch (key) {
    case 'employees':
      return i18n.t('shift_management.filters.view_selector.groups.employee')
    case 'areas':
      return i18n.t('shift_management.filters.view_selector.groups.area')
    case 'daily':
      return i18n.t('shift_management.filters.view_selector.views.daily')
    case 'weekly':
      return i18n.t('shift_management.filters.view_selector.views.weekly')
    case 'four-weeks':
      return i18n.t('shift_management.filters.view_selector.views.four_weeks')
    case 'monthly':
      return i18n.t('shift_management.filters.view_selector.views.monthly')
    default:
      throw new Error(`Missing translation for shift_management.filters.view_selector.views.${key}`)
  }
}

export const viewTypeOptions = (groupType: GroupType): SelectOption[] => {
  const group = ALLOWED_VIEWS_BY_GROUP.find(({ group }: GroupOption) => group === groupType)

  if (!group) return []

  return group.children.reduce((options: SelectOption[], { view, enabled }: ViewByGroup) => {
    if (enabled()) options.push({ value: view, label: labelTranslation(view) })

    return options
  }, [])
}

export const groupTypeOptions = (): SelectOption[] => {
  return ALLOWED_VIEWS_BY_GROUP.reduce(
    (options: SelectOption[], { group, enabled }: GroupOption) => {
      if (enabled()) options.push({ value: group, label: labelTranslation(group) })

      return options
    },
    []
  )
}

export interface NewThemeSelectOption {
  label: string
  // The same type we have in the design system
  value: GroupType
  icon: MediumIcon
  newThemeIcon: IconType
  disabled?: boolean
}

export const newThemeGroupTypeOptions = (): NewThemeSelectOption[] => {
  return ALLOWED_VIEWS_BY_GROUP.reduce(
    (options: NewThemeSelectOption[], { group, icon, enabled, newThemeIcon }: GroupOption) => {
      if (enabled())
        options.push({
          value: group,
          label: labelTranslation(group),
          icon: icon,
          newThemeIcon: newThemeIcon,
        })

      return options
    },
    []
  )
}
